import { render, staticRenderFns } from "./nothing.vue?vue&type=template&id=cf6c5f42&scoped=true"
import script from "./nothing.vue?vue&type=script&lang=ts"
export * from "./nothing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6c5f42",
  null
  
)

export default component.exports